<template>
    <div>



  <b-modal
      id="change-enrollment-grade-modal"
      ref="change-enrollment-grade-modal"
      title="修改課程"
      no-close-on-backdrop
      size="sm"
    >
      <v-select
        style="width: 100%;"
        :options="gradeOptions"
        label="label"
        :clearable="false"
        :append-to-body="true"
        class="center-select"
        :reduce="grade => grade.grade_id"
        v-model="selected_enrollment.grade_id"
      />
        <template #modal-footer="{ ok, cancel }">
          <b-button  size="sm" variant="outline-secondary" @click="cancel()">
            取消
          </b-button>
          <b-button size="sm" variant="primary" @click="submit_change_enrollment_grade('')">
            確定
          </b-button>

          <b-button size="sm" variant="warning" @click="submit_change_enrollment_grade('all')">
            確定 (全部往後)
          </b-button>
        </template>
    </b-modal>



  <b-modal
      id="change-todo-modal"
      ref="change-todo-modal"
      title="修改畫題"
      no-close-on-backdrop
      size="sm"
    >
        <b-form-input
          v-model="selected_enrollment.todo_content"
          type="text"
          class="form-control"
        />
        <template #modal-footer="{ ok, cancel }">
          <b-button  size="sm" variant="outline-secondary" @click="cancel()">
            取消
          </b-button>
          <b-button size="sm" variant="primary" @click="change_todo_content()">
            確定
          </b-button>
        </template>
    </b-modal>




  <change-enrollment-modal
    ref="changeEnrollmentModal"
    modal-id="change-date-modal-schedule"
    :teacher-options="staffOptions"
    :user-id="selected_enrollment.user_id"
    @changed="get_data"
  />
    <b-overlay
      :show="loading"
      rounded="sm"
    >
    <b-card>
      <b-row>

        <b-col
          cols="12"
          md="2"
          class="align-items-center justify-content-start mb-1 mb-md-0"
        >
        <flat-pickr
          v-model="rangeDate"
          class="form-control mb-1 mr-1"
          :config="{ mode: 'single',dateFormat: 'Y-m-d'}"

        />
        
      </b-col>
      <b-col cols="3" class="d-flex align-items-center mb-1">
        <v-select
          style="width: 80%;"
          :options="scheduleStaffOptions"
          label="label"
          :clearable="false"
          :append-to-body="true"
           class="center-select mr-50"
          :reduce="staff => staff.value"
           v-model="staff_id"
           @input="get_data()" 
           />
           <v-select
            style="width: 60%;"
          :options="scheduleStartOptions"
          label="label"
          :clearable="false"
          :append-to-body="true"
           class="center-select"
          :reduce="staff => staff.value"
           v-model="selected_start"
           @input="get_data()" 
           />
           </b-col>

      <b-col cols="3" class="d-flex align-items-center mb-1">
        <b-badge variant="light-primary" size="sm" class="mr-1" style="cursor: pointer;"  @click="selectAll" >
          全選
        </b-badge>
        <span v-if="selectedEnrollmentIds.length > 0">
        <span class="mr-1">已選 {{ selectedEnrollmentIds.length }} 筆</span>
        <b-badge variant="success" size="sm" class="ml-1" style="cursor: pointer;"  @click="callbackSelected" :disabled="callbackLoading">
          {{ callbackLoading ? '處理中...' : '出席' }}
        </b-badge>
        <b-badge variant="light-warning" size="sm" class="ml-1" style="cursor: pointer;"  @click="clearSelections" >
          清除選擇
        </b-badge>
      </span>
      </b-col>
      <b-col
          cols="12"
          md="2"
          >
          <span v-if="selectedEnrollmentIds.length > 0">
        <v-select
          :options="staffOptions"
          label="label"
          :clearable="false"
          :append-to-body="true"
           class="teacher-select"
          :reduce="teacher => teacher.value"
           v-model="batchTeacherId"
        />
        </span>
        </b-col>
        <b-col
          cols="12"
          md="1"
           class="d-flex align-items-center mb-1"
        >
        <span v-if="selectedEnrollmentIds.length > 0">
        <b-badge variant="light-primary" size="sm"  style="cursor: pointer;"  @click="change_enrollment('user_id', batchTeacherId, selectedEnrollmentIds)" >
          轉老師
        </b-badge>
        </span>
        </b-col>   
        <b-col
          cols="12"
          md="1"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="btn-icon" variant="flat-primary" @click="timetable_print()">
              <feather-icon icon="PrinterIcon" />
            </b-button>
          
            <!-- <b-button
              variant="primary"
              class="mb-1"
              @click="exportToExcel()"
            >
              <span class="text-nowrap">Export</span>
            </b-button> -->
          </div>
        </b-col>
      </b-row>

      <!-- table -->
      <b-table
        ref="selectableTable"       
        :items="items"
        :fields="fields"
        :sticky-header="false"
        :tbody-tr-attr="rowAttributes"
        responsive
        small
        striped
        class="mb-0"
      
      >
      <template #cell(select)="data">
        <b-form-checkbox
          :checked="selectedEnrollmentIds.includes(data.item.enrollment_id)"
          @change="toggleSelect(data.item.enrollment_id)"
        />
      </template>
      <template #cell(is_attend)="data">
        <b-badge class="d-block" variant="success" @click="change_enrollment('is_attend','', data.item)" style="cursor: pointer;" v-if="data.value == 'Y' && data.item.enrollment_status != 'LEAVE'">
            出席
          </b-badge>
          <b-badge  class="d-block" variant="light-warning" @click="change_enrollment('is_attend','Y', data.item)" style="cursor: pointer;"   v-if="data.value != 'Y' && data.item.enrollment_status != 'LEAVE'">
            未出席
        </b-badge>
        <b-badge  class="d-block" variant="danger" v-if="data.item.enrollment_status == 'LEAVE'">
            已請假
        </b-badge>
        <b-badge  class="d-block ml-1" variant="danger" v-if="data.item.enrollment_status == 'NONPAID'" >
            未繳費
        </b-badge>
        
      </template>
      <template #cell(grade_name)="data">
        <b-badge class="d-block cursor-pointer" @click="change_enrollment_grade(data.item)" :style="'background-color:#'+data.item.color+';color:#666;'" v-if="data.item.enrollment_type == 'REGULAR'">
            {{ data.value }}
          </b-badge>
          <b-badge class="d-block" :style="'background-color:#000;color:#fff;'" v-if="data.item.enrollment_type == 'SHORT_COURSE'">
            短期課程
          </b-badge>
          <b-badge class="d-block cursor-pointer" variant="warning" v-if="data.item.enrollment_type == 'TRIAL'" @click="check_form(data.item)">
            試堂 {{ data.value }}
          </b-badge>
      </template>
      <template #cell(student_name)="data">
            <b-link :to="'/apps/student/edit/'+data.item.uuid+'/'"><b>{{data.item.student_id}} {{ data.value }}</b></b-link>
            <b-badge variant="light-danger" class="ml-25">{{ age(data.item.birth) }}</b-badge>
      </template>
      <template #cell(remain_enrollment)="data">
            <b-badge :variant=" (data.item.stats.remain_enrollment > 4 ? 'light-success' : 'danger')" class="ml-25">{{ data.item.stats.remain_enrollment }}</b-badge>
      </template>
      <template #cell(teacher)="data">
        <v-select
          :options="staffOptions"
          label="label"
          :clearable="false"
          :append-to-body="true"
           class="select-size-sm teacher-select"
          :reduce="teacher => teacher.value"
           v-model="data.item.user_id"
           @input="change_enrollment('user_id', data.item.user_id, data.item)"
        />
      </template>

       <template #cell(time)="data">
       {{ data.item.start }} - {{ data.item.end }}
       </template>
       
       <template #cell(other_action)="data">
        <b-button variant="outline-warning" size="sm" @click="change_leave(data.item)" v-if="data.item.enrollment_status != 'LEAVE'">
            請假
          </b-button>
          <b-button class="mx-1" variant="outline-primary" size="sm" @click="open_change_enrollment(data.item)">
            轉堂
          </b-button>
        <b-button variant="outline-primary" size="sm" @click="change_enrollment('change_teacher_future', data.item.user_id, data.item)">
            往後轉導師
          </b-button>
          <b-button class="ml-1" variant="outline-danger" size="sm" @click="change_leave(data.item)" v-if="data.item.enrollment_status == 'LEAVE'">
            取消請假
          </b-button>
       </template>
      <template #cell(stats)="data">
        <b-badge variant="light-primary" class="mr-50" >
            {{ data.value.remain_date_selected }}
        </b-badge>
         <b-badge variant="light-primary" class="mr-50" >
            {{ data.value.remain_date_unselect }}
        </b-badge>
         <b-badge variant="light-primary" class="mr-50" >
            {{ data.value.remain_markup }}
        </b-badge>
         <b-badge variant="light-danger" v-if="data.value.overdue != null">
            {{ data.value.overdue }}
        </b-badge>
      </template>
        
        <template #cell(todo_content)="data">
          <b-badge variant="primary" class="cursor-pointer" @click="change_todo(data.item)">
            {{ data.value === '' || data.value == null ? '未有' : data.value }}
          </b-badge>
        </template>
        <template #cell(code)="data">
          <b-link :to="'/apps/student/edit/'+ data.item.uuid +'/'">
            {{ data.value }}
          </b-link>
        </template>
        <template #cell(zh_name)="data">
          <b-link :to="'/apps/student/edit/'+ data.item.uuid +'/'">
            {{ data.value }}
          </b-link>
        </template>
        <template #cell(amount)="data">
          <span v-if="data.item.status == 'VOID'" style="color:red;"><b> -{{data.item.amount}}</b></span>
          <span v-if="data.item.status == 'ACTIVE'">{{data.item.amount}}</span>
        </template>
      </b-table>
      <b-row>
        <b-col class="mt-1 text-right">
          共有紀錄 : {{ totalRows }} <br> 顯示紀錄第 {{ startRow }} 條 至第 {{ endRow }} 條
        </b-col>
       
      </b-row>
      </b-card>
      </b-overlay>
    </div>
  </template>
  
  <script>
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  
  import vSelect from 'vue-select'
  import Ripple from 'vue-ripple-directive'
  import flatPickr from 'vue-flatpickr-component'
  import ChangeEnrollmentModal from '../member/member-edit/ChangeEnrollmentModal.vue'
  import moment from 'moment'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import {
    BTable, BLink, BAvatar,BCard,BOverlay, BCardBody, BBadge,  BRow, BCol, BFormGroup, BFormSelect, BFormCheckbox, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,BModal, VBModal} from 'bootstrap-vue'
  export default {
    components: {
      moment,
      BLink,
      flatPickr,
      BCard,
      BOverlay,
      BTable,
      ToastificationContent,
      BModal, VBModal,
      BAvatar,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BInputGroupPrepend,
      BButton,
      BFormCheckbox, 
      BPagination,
      BCardCode,
      BTable,
      BButton,
      BFormGroup,
      BAvatar,
      BCardBody,
      BBadge,
      vSelect,
      ChangeEnrollmentModal,
    },
    directives: {
      Ripple,
    },
    data() {
      return {
        iframe_src : '//rb.cloudedu.pro/invoice.php',
        rangeDate: moment().format("YYYY-MM-DD"),
        searchString: null,
        type:'all',
        batchTeacherId:null,
        selected_enrollment: {
            class_date: null,
            class_hour: null,
            class_minute: null,
        },
        loading:false,
        test_string : null,
        headerTitle: ['Center', 'code','grade','Student Name', 'Remain'],
        headerVal: ['center_code', 'code','grade','zh_name', 'remain'],
        genderOptions: [
          { label: 'Male', value: 'M' },
          { label: 'Female', value: 'F' },
        ],
        statusOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Disabled', value: 'disabled' },
        ],
        isAddNewMemberSidebarActive: false,
        selected_start: null,
        center_id : this.$store.getters['center/currentCenterId'],
        searchString: null,
        perPage: 10,
        startRow: 1,
        staffOptions:[],
        year: moment().format("YYYY"),
        endRow: 10,
        totalAmount: 0,
        pageOptions: [10, 15, 20],
        totalRows: 1,
        staff_id: null,
        currentPage: 1,
        fields: [   
                    // { key: 'id', label: '#',sortable:true },
                    { key: 'select', label: '選擇', sortable: false },
                    { key: 'is_attend', label: '點名',sortable:false }, 
                    { key: 'other_action', label: '其他', sortable: false },     
                    { key: 'remain_enrollment', label: '剩餘',sortable:false },
                    { key: 'student_name', label: '學生',sortable:false },
                    { key: 'grade_name', label: '課程',sortable:false },          
                    // { key: 'start', label: '開始',sortable:true },
                    // { key: 'end', label: '結束',sortable:true },
                    { key: 'time', label: '時間',sortable:false },
                    { key: 'todo_content', label: '畫題',sortable:false }, 
                    { key: 'teacher', label: '導師',sortable:false },
                    { key: 'timetable_remarks', label: '備註',sortable:false }, 
                    { key: 'change_from', label: '補堂資料',sortable:false }, 
                ],
      
        items: [],
        selectMode: 'single',
        selected: [],
        selectedEnrollmentIds: [],
        callbackLoading: false,
        scheduleStaffOptions: [],
        scheduleStartOptions: [],
      }
    },
    watch: {
      type: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      rangeDate : {
        handler(newValue, oldValue) {
          this.clearSelections()
          this.get_data()
        },
      },
      currentPage: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
      searchString: {
        handler(newValue, oldValue) {
          // console.log("search")
          this.searchString = newValue.toUpperCase()
          this.handleSearch()
        },
      },
      perPage: {
        handler(newValue, oldValue) {
          if (newValue < 9) {
            this.perPage = 10
          }
          // console.log("search")
          this.handleSearch()
        },
      },
    },
    created() {
      this.get_data()
      this.get_staff_list()
      this.get_grade()
    },
    methods: {
    check_form(id) {
      this.$http.get(process.env.VUE_APP_API_BASE+'/form/check/?type=trial&enrollment_id='+ id.enrollment_id)
        .then(res => {
          if (res.data.result === true) {
            this.$router.replace('form/'+ id.student_id +'/1/?enrollment_id='+id.enrollment_id);
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
      get_grade() {
        this.$http.get(process.env.VUE_APP_API_BASE+`/grades/`)
          .then(res => {
            this.gradeOptions = res.data.grades_enable
          })
      },
      submit_change_enrollment_grade(action) {
        this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/${this.selected_enrollment.enrollment_id}/change_grade/?action=${action}`, {
          grade_id: this.selected_enrollment.grade_id,
          action: action
        })
          .then(res => {
            this.$refs['change-enrollment-grade-modal'].hide()
            this.$toast({
              component: ToastificationContent,
              props: { title: '調整成功', icon: 'CheckIcon', variant: 'success' },
            })
            this.get_data()
          })
      },
      change_leave(enrollment) {
        const action = enrollment.enrollment_status == 'LEAVE' ? 'rollback' : 'absent'
         this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/${enrollment.enrollment_id}/absent/?action=${action}`, {})
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: { title: '請假成功', icon: 'CheckIcon', variant: 'success' },
            })
            this.get_data()
          })
      },
      change_todo(enrollment) {
        this.selected_enrollment = enrollment
        this.$refs['change-todo-modal'].show()
      },
      open_change_enrollment(enrollment) {
        this.selected_enrollment = enrollment
        this.$nextTick(() => {
          this.$refs.changeEnrollmentModal.open(enrollment)
        })
      },
      change_enrollment_grade(enrollment) {
        this.selected_enrollment = enrollment
        this.$refs['change-enrollment-grade-modal'].show()
      },
      change_todo_content(enrollment) {
        this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/${this.selected_enrollment.enrollment_id}/update_todo/`, {
           todo_content: this.selected_enrollment.todo_content         
          })
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: { title: '修改畫題成功', icon: 'CheckIcon', variant: 'success' },
            })
            this.$refs['change-todo-modal'].hide()
            this.get_data()
          })
      },
      timetable_print() {
        const date = moment(this.rangeDate).format('YYYY-MM-DD')
        window.open("//rb.cloudedu.pro/timetable-v3.php?token="+ JSON.parse(localStorage.getItem('userData')).token +"&date=" + date + "&center_id="+this.$store.getters['center/currentCenterId'],"_blank")
      },
      age(dob) {
      // return dob+" "+moment().diff( dob, 'months',false)
        var a = moment();
        var b = moment(dob, 'YYYY-MM-DD');
        var age = moment.duration(a.diff(b));
        var years = age.years();
        var months = age.months();
        var month_string = ''
        if (months > 0 ) { month_string = months +"個月" }
        return  years + "歲" + month_string 
      },
      toggleSelect(enrollmentId) {
        const idx = this.selectedEnrollmentIds.indexOf(enrollmentId)
        if (idx === -1) {
          this.selectedEnrollmentIds.push(enrollmentId)
        } else {
          this.selectedEnrollmentIds.splice(idx, 1)
        }
      },
      clearSelections() {
        this.selectedEnrollmentIds = []
      },
      selectAll () {
        this.selectedEnrollmentIds = this.items.map(item => item.enrollment_id)
      },
      callbackSelected() {
        if (this.selectedEnrollmentIds.length === 0) return
        this.callbackLoading = true
        this.$http.post(process.env.VUE_APP_API_BASE + '/enrollment/batch/change_enrollment/', {
          enrollment_ids: this.selectedEnrollmentIds,
          field: 'is_attend',
          value: 'Y',
        })
          .then(res => {
            this.$toast({
              component: ToastificationContent,
              props: { title: '操作成功', icon: 'CheckIcon', variant: 'success' },
            })
            this.selectedEnrollmentIds = []
            this.get_data()
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: { title: '操作失敗', icon: 'XIcon', variant: 'danger' },
            })
          })
          .finally(() => {
            this.callbackLoading = false
          })
      },
      onTeacherChange(teacherId, item) {
        this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/${item.enrollment_id}/change_teacher/`, { user_id: teacherId })
          .then(res => {
          })
      },
      change_enrollment(field, value, enrollmentIds) {
        this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/batch/change_enrollment/`, { field : field, value: value, enrollment_ids: enrollmentIds })
          .then(res => {
            this.get_data()
          })
      },
      rowAttributes(item, type) {
        if (type !== 'row' || !item || !item.row_color) {
          return {}
        }

        const backgroundColor = this.normalizeRowColor(item.row_color)
        if (!backgroundColor) {
          return {}
        }

        return {
          style: `background-color: ${backgroundColor};`,
        }
      },
      normalizeRowColor(color) {
        if (!color || typeof color !== 'string') {
          return null
        }

        const trimmed = color.trim()
        if (!trimmed) {
          return null
        }

        if (trimmed.startsWith('#') || trimmed.startsWith('rgb') || /^[a-zA-Z]+$/.test(trimmed)) {
          return trimmed
        }

        return `#${trimmed}`
      },
      get_staff_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/?center_id='+this.center_id)
        .then(res => {
          this.staffOptions = res.data
        })
    },
      exportToExcel() {
        console.log(this.items)
        console.log(this.headerTitle)
        import('@/@core/Export2Excel').then(excel => {
          const list = this.items
          const data = this.formatJson(this.headerVal, list)
          excel.export_json_to_excel({
            header: this.headerTitle,
            data,
            filename: 'Expire_'+this.rangeDate,
            autoWidth: true,
            bookType: 'xlsx'
          })
          //this.clearFields()
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            // Add col name which needs to be translated
            // if (j === 'timestamp') {
            //   return parseTime(v[j])
            // } else {
            //   return v[j]
            // }
  
            return v[j]
          })
        )
      },
      get_data(searchString = null) {
        this.loading = true
        this.$http.get(process.env.VUE_APP_API_BASE+`/report/daily-schedule/?start=` + this.selected_start + `&center=` + this.center_id + `&date=`+ this.rangeDate + `&staff_id=` + this.staff_id)
          .then(res => {
            this.items = res.data.enrollments || []
            this.scheduleStaffOptions = res.data.staff || []
            this.scheduleStartOptions = res.data.start || []
            this.totalRows = this.items.length
            this.totalAmount = 0
              console.log( res.data )
              this.items.forEach((item, i) => {
                if (item.status == 'ACTIVE') {
                  this.totalAmount += parseInt(item.amount)
                }
              });
              this.loading = false
          })
      },
      handleChangePage() {
  
      //  this.get_data()
      },
      onRowSelected(items) {
        this.selected = items[0]
        this.iframe_src = '//rb.cloudedu.pro/pdf/INVOICE_'+items[0].code+'.pdf'
        this.transaction_id = items[0].transaction_id
        this.$refs['my-modal'].show()
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      selectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.selectRow(2)
      },
      unselectThirdRow() {
        // Rows are indexed from 0, so the third row is index 2
        this.$refs.selectableTable.unselectRow(2)
      },
  
      handleSearch() {
        // let _print = `The user searched for: ${searching}\n`
        // this.$refs.pre.appendChild(document.createTextNode(_print))
      // this.searchString = searching
      // this.currentx = 1
      // this.get_data()
        this.searchTimeOut()
      },
      searchTimeOut() {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }
        this.timer = setTimeout(() => {
          // your code
          this.currentPage = 1
          this.get_data(this.searchString)
        }, 500)
      },
    },
  }
  </script>
  <style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  </style>
  <style lang="scss">
  .b-table-selectable{
    .feather{
      font-size: 1.3rem;
    }
  }

  .teacher-select {
    min-width: 150px;
  }

  body .vs__dropdown-menu {
    z-index: 9999 !important;
  }
  body .vs__dropdown-toggle {
    background-color: #fff;
  }
  </style>
  